import { useAbility } from '@cast/shared-ability-data-access';

export const useCommitmentsAbilities = () => {
  const [canEdit] = useAbility().canMany([
    ['update', 'OrganizationCommitments'],
  ]);

  return { canEdit };
};
